module.exports = __webpack_public_path__ + "img/content2.d5c18e68.png";